import cacheService from '../../../services/cacheService';
import eventBus from '../../../services/globalEventBus';
import submitCommand from '../../../services/submitCommand';
import { generateUUID } from '../../../services/uuid';
import { TrialLicenseGrantedEventResponse } from '../models/response';

export const grantTrialLicensesFromCode: (
  ownerID: string,
  orgID: string,
  zipCode: string,
  initiatingUserID: string,
  trialCode: string,
  requestedAgeGroups: string[]
) => Promise<TrialLicenseGrantedEventResponse[]> = (
  ownerID,
  orgID,
  zipCode,
  initiatingUserID,
  trialCode,
  requestedAgeGroups
) => {
  const expectedCount = requestedAgeGroups.length;

  return new Promise<TrialLicenseGrantedEventResponse[]>((resolve, reject) => {
    const collectedEvents: TrialLicenseGrantedEventResponse[] = [];
    const unsubscribes: (() => void)[] = [];
    let hasRejected = false;

    const cleanup = () => {
      unsubscribes.forEach(unsubscribe => unsubscribe());
    };

    unsubscribes.push(
      eventBus.subscribe('TrialLicenseGranted', (event: { licenseItemNumber: string }) => {
        if (hasRejected) return;

        collectedEvents.push({
          licenseItemNumber: event.licenseItemNumber,
        });

        if (collectedEvents.length >= expectedCount) {
          cleanup();
          setTimeout(() => resolve(collectedEvents), 2000);
        }
      })
    );

    unsubscribes.push(
      eventBus.subscribe('GrantTrialLicenseFailed', (event: { reason?: string }) => {
        if (hasRejected) return;
        hasRejected = true;
        cleanup();
        reject(event);
      })
    );

    cacheService.removeAllInPath(`/v1/org/curriculum/access`);
    cacheService.removeAllInPath(`/v1/licenses`);

    generateUUID((id: string) => {
      submitCommand(
        id,
        { id, ownerID, orgID, zipCode, initiatingUserID, trialCode, requestedAgeGroups },
        'GrantTrialLicenseFromCode',
        'TrialLicenseGranted',
        'GrantTrialLicenseFailed'
      ).catch(error => {
        if (!hasRejected) {
          hasRejected = true;
          cleanup();
          reject(error);
        }
      });
    });
  });
};
